import { TitleCasePipe } from '@angular/common';
import { TriggerTypePipe } from '@app/_shared/pipes/trigger-type/trigger-type.pipe';
import { ORDER_MODE, ORDER_STATUS, PRODUCT_TYPE_NUM, ORDER_CONDITION, ALERT_TYPE, INSTRUMENT_MAP, ORDER_TYPE_ENUM, ORDER_CONDITION_ENUM } from '@app/_shared/shared.enums';
import { OrderValidityEnum } from '@app/_shared/modules/strategy-form/strategy.enums';

let titleCasePipe: TitleCasePipe;
let triggerTypePipe: TriggerTypePipe;

function getTitleCasePipe(): TitleCasePipe {
  if (!titleCasePipe) {
    titleCasePipe = new TitleCasePipe();
  }
  return titleCasePipe;
}

function getTriggerTypePipe(): TriggerTypePipe {
  if (!triggerTypePipe) {
    triggerTypePipe = new TriggerTypePipe();
  }
  return triggerTypePipe;
}

export function formatOrderBookCondition(orderCondition: string, triggerType?: number | string): string {
  if (orderCondition === ORDER_CONDITION_ENUM.EXIT) {
    const triggerTypeValue = typeof triggerType === 'string' ? Number(triggerType) : triggerType;
    const label = getTriggerTypePipe().transform(triggerTypeValue) as string;
    return label ?? getTitleCasePipe().transform(orderCondition);
  }
  return getTitleCasePipe().transform(orderCondition);
}

export function getPipeMap() {
  return {
    'order_mode': ORDER_MODE,
    'order_status': ORDER_STATUS,
    'product_type': PRODUCT_TYPE_NUM,
    'product': PRODUCT_TYPE_NUM,
    'order_condition': ORDER_CONDITION,
    'strategy_type': ALERT_TYPE,
    'instrument': INSTRUMENT_MAP,
    'order_type': ORDER_TYPE_ENUM,
    'order_validity': OrderValidityEnum,
    'position_type': ALERT_TYPE
  }
}
